/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import {
  IconWrapper,
  ItemsPerPage,
  IPPLabel,
  PaginationAndGTP,
  PaginationContainer,
  PaginationWrapper,
  SelectWrapper,
} from './style';
import Icon from '../Icon';
import CustomSelect from '../CustomSelect';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';
import {
  ITEMS_PP_OPTIONS,
  getGoToPageOptions,
} from '../../../utils/pagination';

const Pagination = ({
  mediaIsPhone,
  pager,
  callBack,
  setItemsPerPage,
  hideGoToPage,
  pt,
  pb,
  isDisabled,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [goToPageOpts, setGoToPageOpts] = useState([]);
  const [itemsPPOpts, setItemsPPOpts] = useState([]);

  const handlePageClick = (event) => {
    callBack(event.selected);
    setCurrentPage(event.selected);
  };

  const goToPage = (pageNumber, disabled) => {
    if (disabled) return null;
    callBack(pageNumber);
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    setItemsPPOpts(ITEMS_PP_OPTIONS);
    setGoToPageOpts(getGoToPageOptions(pager));
  }, [pager]);

  return pager?.number_of_pages > 1 ? (
    <PaginationWrapper pt={pt} pb={pb} className={isDisabled ? 'disabled' : ''}>
      {isDisabled && <div className="overlay" />}
      <PaginationAndGTP>
        <PaginationContainer>
          <IconWrapper
            className={currentPage === 0 ? 'disabled' : ''}
            onClick={() => goToPage(0, currentPage === 0)}
          >
            <Icon type="chevron-left-double" />
          </IconWrapper>
          <IconWrapper
            className={currentPage === 0 ? 'disabled' : ''}
            onClick={() => goToPage(currentPage - 1, currentPage === 0)}
          >
            <Icon type="chevron-left" />
          </IconWrapper>
          <ReactPaginate
            pageCount={pager?.number_of_pages}
            breakLabel="..."
            onPageChange={handlePageClick}
            pageRangeDisplayed={mediaIsPhone ? 2 : 3}
            marginPagesDisplayed={0}
            renderOnZeroPageCount={null}
            forcePage={currentPage}
          />
          <IconWrapper
            className={
              currentPage + 1 === pager?.number_of_pages ? 'disabled' : ''
            }
            onClick={() =>
              goToPage(
                currentPage + 1,
                currentPage + 1 === pager?.number_of_pages
              )
            }
          >
            <Icon type="chevron-left" rotate={180} />
          </IconWrapper>
          <IconWrapper
            className={
              currentPage + 1 === pager?.number_of_pages ? 'disabled' : ''
            }
            onClick={() =>
              goToPage(
                pager.number_of_pages - 1,
                currentPage + 1 === pager?.number_of_pages
              )
            }
          >
            <Icon type="chevron-left-double" rotate={180} />
          </IconWrapper>
        </PaginationContainer>
        {!hideGoToPage && goToPageOpts?.length > 0 && (
          <SelectWrapper>
            <CustomSelect
              options={goToPageOpts}
              selected={
                goToPageOpts.find((o) => o.value === currentPage + 1) ||
                goToPageOpts[0]
              }
              onChange={(v) => goToPage(v?.value - 1)}
            />
          </SelectWrapper>
        )}
      </PaginationAndGTP>
      {typeof setItemsPerPage === 'function' && itemsPPOpts?.length > 0 && (
        <ItemsPerPage>
          <IPPLabel>Mostra risultati in pagina:</IPPLabel>
          <SelectWrapper>
            <CustomSelect
              options={itemsPPOpts}
              selected={
                itemsPPOpts.find((o) => o.value === pager?.items_per_page) ||
                itemsPPOpts[0]
              }
              onChange={setItemsPerPage}
            />
          </SelectWrapper>
        </ItemsPerPage>
      )}
    </PaginationWrapper>
  ) : null;
};

Pagination.propTypes = {
  mediaIsPhone: PropTypes.bool,
  pager: PropTypes.object.isRequired,
  callBack: PropTypes.func.isRequired,
  setItemsPerPage: PropTypes.func,
  pt: PropTypes.number,
  pb: PropTypes.number,
  hideGoToPage: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

export default withMediaQueries(Pagination);
